function hashCode(str: string) {
  let hash = 0,
    i,
    chr,
    len
  if (!str || str.length === 0) {
    return hash
  }
  for (i = 0, len = str.length; i < len; i++) {
    chr = str.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0 // Convert to 32bit integer
  }

  return hash < 0 ? ~hash : hash
}

export function getInitials(name: string, isTwoInitials?: boolean) {
  if (typeof name !== 'string') {
    return ''
  }

  const names = name.split(' ')
  const { length } = names

  return length > 1 && isTwoInitials
    ? names[0].charAt(0).toUpperCase() + names[length - 1].charAt(0).toUpperCase()
    : names[0].charAt(0).toUpperCase()
}

export function generateColor(str: string) {
  return ['#C767A7', '#749EDA', '#9768AC', '#E3AC2D', '#9AC562', '#749EDA'][hashCode(str) % 5]
}
